<template>
  <b-overlay
      :show="showOverlay"
      rounded="sm"
  >
    <div>

      <!-- Table Container Card -->
      <b-card
          no-body
          class="mb-0"
      >

        <div class="m-2">

          <!-- Table Top -->
          <b-row>

            <b-col
                cols="12"
                md="2"
                class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <span> تعداد کل : </span>
              <span class="mx-1">{{ totalCount }}</span>
            </b-col>

            <b-col
                cols="12"
                md="3"
                class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <label>نمایش</label>
              <v-select
                  v-model="count"
                  :options="perPageOptions"
                  :clearable="false"
                  class="per-page-selector mx-50 w-50"
              />
              <label>تعداد</label>
            </b-col>
            <b-col
                cols="12"
                md="2"
            >
              <div class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
                <b-form-input
                    v-model="debouncedUserFullNameSearchCommand"
                    class="d-inline-block mr-1"
                    placeholder="جستجوی نام و نام خانوداگی ..."
                />
              </div>
            </b-col>
            <b-col
                cols="12"
                md="2"
            >
              <div class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
                <b-form-input
                    v-model="debouncedNationalIdSearchCommand"
                    class="d-inline-block mr-1"
                    placeholder="جستجوی کد ملی ..."
                />
              </div>
            </b-col>
            <b-col
                cols="12"
                md="2"
            >
              <div class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
                <b-form-input
                    v-model="debouncedMobileSearchCommand"
                    class="d-inline-block mr-1"
                    placeholder="جستجوی شماره موبایل ..."
                />
              </div>
            </b-col>
          </b-row>
          <b-col
              cols="12"
              md="2"
              class="d-flex align-items-center justify-content-start"
          >
            <b-button
                variant="success"
                class=""
                :block="$store.getters['app/currentBreakPoint'] === 'xs'"
                @click="downloadFile"
            >
              دانلود اکسل لیست
            </b-button>
          </b-col>

        </div>

        <b-table
            ref="refUserListTable"
            class="position-relative"
            :items="data"
            responsive
            :fields="myTableColumns"
            primary-key="id"
            show-empty
            bordered
            striped
            empty-text="موردی موجود نیست!"
        >
          <!-- Column: createDate -->
          <template #cell(createDate)="data">
            <span>
              {{ data.item.createDate.slice(11, 16) }}
              -
              {{ createJalaliDate(data.item.createDate.slice(0, 10)) }}
            </span>
          </template>

          <!-- Column: reason -->
          <template #cell(reason)="data">
            <span v-if="data.item.reason === 0">-</span>
            <span v-if="data.item.reason === 1">تلاش برای کپی کردن ویدیو</span>
            <span v-if="data.item.reason === 2">ورود با بیش از یک دستگاه</span>
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>

            <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <!--            <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span>-->
            </b-col>
            <!-- Pagination -->
            <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <QueriedPagination v-if="totalCount" v-model="pageNumber" :total-counts="totalCount"
                                 :per-page="count"></QueriedPagination>
            </b-col>

          </b-row>
        </div>
      </b-card>
    </div>
    <!--    <b-modal-->
    <!--        id="modal-delete"-->
    <!--        centered-->
    <!--        ok-title="حذف"-->
    <!--        cancelTitle="انصراف"-->
    <!--        @ok="deleteCoupon(deleteItem)"-->
    <!--    >-->
    <!--      <span>حذف شود؟</span>-->
    <!--    </b-modal>-->
  </b-overlay>
</template>

<script>
import {
  BAvatar,
  BBadge,
  BButton,
  BCard,
  BCol,
  BDropdown,
  BDropdownItem,
  BFormInput,
  BLink,
  BMedia,
  BModal,
  BOverlay,
  BPagination,
  BRow,
  BTable,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Helper from "@/libs/Helper";
import {UsersGetTransgressesRequest} from "@/libs/Api/Users";
import QueriedPagination from "@/views/components/QueriedPagination.vue";
import {getUserData} from "@/auth/utils";
import axiosIns from "@/libs/axios";
import {saveAs} from 'file-saver';
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  title: 'لیست تخلفات - پنل ادمین بنفشه باقری ',
  data() {
    return {
      timeOutForMobileSearchCommand: null,
      timeOutForNationalIdSearchCommand: null,
      timeOutForUserFullNameSearchCommand: null,
      coupons: null,
      data: [],
      showOverlay: false,
      totalCount: null,
      addNewCategory: false,
      currentPage: 1,
      deleteItem: null,
      perPage: 10,
      pageNumber: 1,
      count: 10,
      searchCommand: '',
      perPageOptions: [10, 20, 30, 40, 50],
      userFullNameSearchCommand: '',
      nationalIdSearchCommand: '',
      mobileSearchCommand: '',
      myTableColumns: [
        {key: 'user.fullName', label: 'اطلاعات کاربر'},
        {key: 'user.userName', label: 'نام کاربری'},
        {key: 'user.nationalId', label: 'کد ملی'},
        {key: 'user.mobile', label: 'موبایل'},
        {key: 'createDate', label: 'تاریخ ثبت'},
        {key: 'reason', label: 'تخلف'},
        // { key: 'tryCopingVideoCount',label:'تعداد دفعات تلاش برای کپی'},
        // { key: 'useAppMoreThan2DeviceCount',label:'تعداد دفعات ورود با بیش از دو دستگاه'},
      ],
    }
  },
  async created() {
    if (this.$route.query.pageNumber) {
      this.pageNumber = +this.$route.query.pageNumber
      this.currentPage = +this.$route.query.pageNumber
    }
    await this.getTransgresses(this.pageNumber, this.count)
  },
  methods: {
    async getTransgresses(pageNumber, count, userFullNameSearchCommand, nationalIdSearchCommand, mobileSearchCommand) {
      let _this = this;
      _this.showOverlay = true;

      let data = {
        page: pageNumber,
        size: count,
        name: userFullNameSearchCommand ?? '',
        nationalId: nationalIdSearchCommand ?? '',
        mobile: mobileSearchCommand ?? '',
      }

      let usersGetTransgressesRequest = new UsersGetTransgressesRequest(_this);
      usersGetTransgressesRequest.setParams(data);
      await usersGetTransgressesRequest.fetch(function (content) {
        _this.data = content.data.data;
        _this.totalCount = content.data.totalCount;
        _this.showOverlay = false;
      }, function (error) {
        _this.showOverlay = false;
        console.log(error)
      })
    },
    createJalaliDate(param) {
      return new Date(param).toLocaleDateString("fa-IR",);
    },
    makePrettyPrice(param) {
      return Helper.prettyPrice(param, 0)
    },
    showModal(param) {
      let _this = this;
      _this.deleteItem = param
    },
    async downloadFile() {
      let _this = this;
      this.$store.commit('app/TOGGLE_DOWNLOAD')
      let userToken = getUserData().token;

      await axiosIns.post(`/Users/GetTransgressesExcel`, null, {
        responseType: 'blob',
      }).then(resp => {
        saveAs(resp.data, 'لیست تخلفات.xlsx');
      }).catch((error) => {
        _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            title: 'عملیات ناموق!',
            icon: 'CheckIcon',
            variant: 'danger',
            text: 'به علت ترافیک بالا سرور لطفا 30 دقیقه دیگر امتحان کنید',
          },
        })
      }).finally(() => {
        this.$store.commit('app/TOGGLE_DOWNLOAD')
      });
    },
  },
  watch: {
    getQuery: function (nv, ov) {
      this.getTransgresses(this.pageNumber, this.count, this.userFullNameSearchCommand, this.nationalIdSearchCommand, this.mobileSearchCommand);
    },
    // currentPage:function (nv,ov) {
    //   this.getTransgresses(nv,this.count);
    // },
    count: function (nv, ov) {
      // this.getTransgresses(this.currentPage,nv);
    },
  },
  computed: {
    getQuery() {
      return this.$route.query
    },
    debouncedUserFullNameSearchCommand: {
      get() {
        return this.userFullNameSearchCommand
      },
      set(val) {
        if (this.timeOutForUserFullNameSearchCommand) {
          clearTimeout(this.timeOutForUserFullNameSearchCommand)
        }
        this.timeOutForUserFullNameSearchCommand = setTimeout(async () => {
          this.userFullNameSearchCommand = val;
          await this.getTransgresses(this.pageNumber, this.count, this.userFullNameSearchCommand, this.nationalIdSearchCommand, this.mobileSearchCommand)
        }, 600)
      }
    },
    debouncedNationalIdSearchCommand: {
      get() {
        return this.nationalIdSearchCommand
      },
      set(val) {
        if (this.timeOutForNationalIdSearchCommand) {
          clearTimeout(this.timeOutForNationalIdSearchCommand)
        }
        this.timeOutForNationalIdSearchCommand = setTimeout(async () => {
          this.nationalIdSearchCommand = val;
          await this.getTransgresses(this.pageNumber, this.count, this.userFullNameSearchCommand, this.nationalIdSearchCommand, this.mobileSearchCommand)
        }, 600)
      }
    },
    debouncedMobileSearchCommand: {
      get() {
        return this.mobileSearchCommand
      },
      set(val) {
        if (this.timeOutForMobileSearchCommand) {
          clearTimeout(this.timeOutForMobileSearchCommand)
        }
        this.timeOutForMobileSearchCommand = setTimeout(async () => {
          this.mobileSearchCommand = val;
          await this.getTransgresses(this.pageNumber, this.count, this.userFullNameSearchCommand, this.nationalIdSearchCommand, this.mobileSearchCommand)
        }, 600)
      }
    },

  },
  components: {
    QueriedPagination,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BOverlay,
    BModal,

    vSelect,
  },
}
</script>

<style scoped>

</style>
